import { ActionPointInfo, Controller, CustomArgs, IActionPointInfo, Menu, Toolbar } from '@tencent/workbench';
import { aiReviewConfig, TOOLBAR_ITEMS } from './ai-review.config';
import { AiReviewService } from '@framework/workbench/ui/ai-review/ai-review-service';
import { tdw } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/tdw-report';
import {
    TDWActionType,
    TDWModuleType,
    TDWOperationType,
} from '@src/slide/infrastructure/module/dependent/report/offline-data-report/constant';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';
import { IPcEditorAppServices } from '@src/slide/application/entry/toc/editor/pc/pc-editor-app-services.interface';
import { getToggleStatusByType, ToggleType } from '@src/slide/infrastructure/module/dependent/config/toggle-config';
import DocsConfig from '@tencent/docs-config';
import { ToolbarFileMenuConfig } from '@src/slide/infrastructure/module/dependent/config/config-manager-constants';

@Controller({
    toolbarItems: TOOLBAR_ITEMS,
})
export class AiReviewController {
    public constructor(private readonly feature: AiReviewService) {
    }

    @Toolbar(aiReviewConfig.id, 'onClick')
    public onClick() {
        // 排版检查和 AI 区域有重叠，手动关闭 AI 助手
        this.feature.getAppService().editableServiceLayer?.aiService?.promise().then((aiService) => {
            aiService.hideSideBar();
        });

        tdw({
            opername: TDWOperationType.DOC_PPT_AI,
            module: TDWModuleType.FULL_REVIEW,
            action: TDWActionType.AI_CLK,
            ver5: TDWModuleType.PC,
            ver: TDWModuleType.AI_TOOLBAR,
        });

        this.feature.showDrawer();
    }

    @Toolbar(aiReviewConfig.id, 'shouldHide')
    public shouldHide() {
        // 母版编辑下隐藏入口
        const isMasterEditType = !!(AppServiceProvider.getInstance().getAppServices() as IPcEditorAppServices)
            .editableServiceLayer?.masterLayoutEditService.isMasterEditType;
        // ToggleConfig 对 AI-Float 的开关
        const EnabledByToggleConfig = (getToggleStatusByType(ToggleType.AI_FLOAT_BAR) ?? true);
        return !(DocsConfig.getInstance().getConfig(ToolbarFileMenuConfig.aiGeneratePage) ?? false)
            || isMasterEditType
            || !EnabledByToggleConfig;
    }
}
